import { NotificationsState } from './types'

export const initialState: NotificationsState = {
  notifications: [],
}
